/* eslint-disable max-len */
import React, { useState, useEffect, useRef, useCallback } from 'react';
import { Grid, Box } from '@mui/material';
import MainCard from '../../../../../../../UiComponents/Cards/MainCard';
// import ButtonTabs from '../../../../../../ResourcesRevised/Components/Resuable/ButtonTabs';
import { ContentTypeKey } from '../../../../../../ResourcesRevised/types';
import ArticlesCardsList from './ContentCards/ArticlesCardsList';
import VideosCardsList from './ContentCards/VideosCardsList';
import ImagesCardsList from './ContentCards/ImagesCardsList';
import PodcastsCardsList from './ContentCards/PodcastsCardsList';
import DocumentsCardsList from './ContentCards/DocumentsCardsList';
import PlaylistsCardsList from './ContentCards/PlaylistsCardsList';
import CategoryCardsList from './ContentCards/CategoryCardsList';
import { useLocation, useParams, useSearchParams } from 'react-router-dom';
import NoData from '../../../../../../../components/Common/NoData';

interface GLobalSearchListProps {
	StatusVisible?: boolean;
	ContentView?: any;
	showPath?: boolean | string;
	searchValue?: string;
}

// common component for all content cards
const GLobalSearchList: React.FC<GLobalSearchListProps> = ({
	StatusVisible = true,
	ContentView = 'grid',
	showPath = false,
	searchValue
}) =>
{
	// const { language } = useContext(LanguageContext);
	// const {
	// 	isArticlesEnabled,
	// 	isImagesEnabled,
	// 	isVideosEnabled,
	// 	isDocumentsEnabled,
	// 	isPodcastsEnabled,
	// 	isPlaylistsEnabled
	// } = useContentPermissions();

	// State for managing content type selection
	const [ selectedContent, setSelectedContent ] = useState<ContentTypeKey | 'categories' | 'subcategories'>('all');

	// Items per view based on screen size
	const [ itemsPerView, setItemsPerView ] = useState<number>(5);

	// Track if at least one section has data
	const [ hasAnyData, setHasAnyData ] = useState(true);
	const dataTracker = useRef<any>({});

	const location = useLocation();
	const { type, categoryId } = useParams();
	const isFavorites = type === 'favorites';
	const showCategories = !location.pathname.includes('section-view') && !isFavorites;
	const [ searchParams ] = useSearchParams();
	const status = searchParams.get('status') ||
	(location.pathname.includes('resource/playlist')
		? 'playlists'
		: '');
	// Update items per view based on screen size

	useEffect(() =>
	{
		const updateItemsPerView = () =>
		{
			if (window.innerWidth <= 600)
			{
				setItemsPerView(1);
			}
			else if (window.innerWidth >= 601 && window.innerWidth <= 899)
			{
				setItemsPerView(3);
			}
			else if (window.innerWidth >= 900 && window.innerWidth <= 1200)
			{
				setItemsPerView(3);
			}
			else if (window.innerWidth >= 1200)
			{
				setItemsPerView(5);
			}
		};

		updateItemsPerView();
		window.addEventListener('resize', updateItemsPerView);

		return () =>
		{
			window.removeEventListener('resize', updateItemsPerView);
		};
	}, []);

	// Handle content type change from ButtonTabs
	const handleContentTypeChange = (key: ContentTypeKey) =>
	{
		setSelectedContent(key === selectedContent ? 'all' : key);
	};

	// Empty functions for props that are required by card list components
	const emptySelectedItems: string[] = [];
	const emptyHandleCheckboxChange = () => {};
	const emptyHandleBulkSelectionUpdate = () => {};

	// Single callback to track if sections have data
	const reportSectionData = useCallback((section: string, hasData: boolean) =>
	{
		if (hasData)
		{
			dataTracker.current[section] = true;
		}
		else
		{
			dataTracker.current[section] = false;
		}
		// if (Object.values(dataTracker.current).length === 8)
		// {
		// 	setHasAnyData(Object.values(dataTracker.current).some((value) => value));
		// }
		if (Object.values(dataTracker.current).some((value) => value))
		{
			setHasAnyData(true);
		}
		else if (Object.values(dataTracker.current).every((value) => !value))
		{
			setHasAnyData(false);
		}
	}, []);

	useEffect(() =>
	{
		Object.keys(dataTracker.current).forEach((key) =>
		{
			dataTracker.current[key] = true;
		});
		setHasAnyData(true);
	}, [ searchValue ]);

	// Check if we should show "No data found"
	const isSearching = searchValue && searchValue.trim() !== '';
	const shouldShowNoData = isSearching && !hasAnyData;

	return (
		<>
			<MainCard sx={{ width: '100%', overflow: 'visible' }}>
				{/* <Stack
					direction={'row'}
					width={'100%'}
					alignItems={'center'}
					justifyContent={'space-between'}
					sx={{ mb: 2 }}
				>
					<ButtonTabs
						selected={selectedContent}
						onChange={handleContentTypeChange}
					/>
				</Stack> */}

				{shouldShowNoData && (
					<Box
						sx={{
							display        : 'flex',
							justifyContent : 'center',
							alignItems     : 'center',
							minHeight      : '400px'
						}}
					>
						<NoData
							noDataHead='No data found'
							src1='/images/cardnodata.svg'
							heightimg='100px'
							widthimg='100px'
							color='lightTxt'
						/>
					</Box>
				)}

				<Box sx={{ display: shouldShowNoData ? 'none' : 'block' }}>
					{status === 'playlists' &&
					<Grid
						container
						direction={'column'}
						width={'100%'}
						overflow={'visible'}
					>
						{/* Playlists section - only visible when status is 'playlists' */}
						{(selectedContent === 'all' || selectedContent === 'playlists') && (
							<PlaylistsCardsList
								selectedItems={emptySelectedItems}
								handleCheckboxChange={emptyHandleCheckboxChange}
								handleBulkSelectionUpdate={emptyHandleBulkSelectionUpdate}
								onCountUpdate={(count) => reportSectionData('playlists', count > 0)}
								selectAll={false}
								showPath={showPath as boolean}
								StatusVisible={StatusVisible}
								ContentView={ContentView}
								itemsPerView={itemsPerView}
								// viewAll={selectedContent === 'playlists'}
								viewAll
								handleViewAll={handleContentTypeChange}
								searchValue={searchValue}
							/>
						)}
					</Grid>}

					{status !== 'playlists' &&
					<Grid
						container
						direction={'column'}
						width={'100%'}
						overflow={'visible'}
					>
						{showCategories && (selectedContent === 'all' || selectedContent === 'categories') &&
					!categoryId &&
					(
						<CategoryCardsList
							viewAll={selectedContent === 'categories'}
							handleViewAll={handleContentTypeChange}
							// itemsPerView={itemsPerView}
							searchValue={searchValue}
							onCountUpdate={(count) => reportSectionData('categories', count > 0)}
						/>
					)}
						{showCategories && (selectedContent === 'all' || selectedContent === 'subcategories') && (
							<CategoryCardsList
								viewAll={selectedContent === 'subcategories'}
								handleViewAll={handleContentTypeChange}
								// itemsPerView={itemsPerView}
								searchValue={searchValue}
								subcategoryOnly
								onCountUpdate={(count) => reportSectionData('subcategories', count > 0)}
							/>
						)}

						{/* Articles section - only visible when selected */}
						{(selectedContent === 'all' || selectedContent === 'articles') && (
							<ArticlesCardsList
								selectedItems={emptySelectedItems}
								handleCheckboxChange={emptyHandleCheckboxChange}
								handleBulkSelectionUpdate={emptyHandleBulkSelectionUpdate}
								onCountUpdate={(count) => reportSectionData('articles', count > 0)}
								selectAll={false}
								showPath={showPath as boolean}
								StatusVisible={StatusVisible}
								ContentView={ContentView}
								itemsPerView={itemsPerView}
								viewAll={selectedContent === 'articles'}
								handleViewAll={handleContentTypeChange}
								searchValue={searchValue}
							/>
						)}

						{/* Videos section - only visible when selected */}
						{(selectedContent === 'all' || selectedContent === 'videos') && (
							<VideosCardsList
								selectedItems={emptySelectedItems}
								handleCheckboxChange={emptyHandleCheckboxChange}
								handleBulkSelectionUpdate={emptyHandleBulkSelectionUpdate}
								onCountUpdate={(count) => reportSectionData('videos', count > 0)}
								selectAll={false}
								showPath={showPath as boolean}
								StatusVisible={StatusVisible}
								ContentView={ContentView}
								itemsPerView={itemsPerView}
								viewAll={selectedContent === 'videos'}
								handleViewAll={handleContentTypeChange}
								searchValue={searchValue}
							/>
						)}

						{/* Images section - only visible when selected */}
						{(selectedContent === 'all' || selectedContent === 'images') && (
							<ImagesCardsList
								selectedItems={emptySelectedItems}
								handleCheckboxChange={emptyHandleCheckboxChange}
								handleBulkSelectionUpdate={emptyHandleBulkSelectionUpdate}
								onCountUpdate={(count) => reportSectionData('images', count > 0)}
								selectAll={false}
								showPath={showPath as boolean}
								StatusVisible={StatusVisible}
								ContentView={ContentView}
								itemsPerView={itemsPerView}
								viewAll={selectedContent === 'images'}
								handleViewAll={handleContentTypeChange}
								searchValue={searchValue}
							/>
						)}

						{/* Podcasts section - only visible when selected */}
						{(selectedContent === 'all' || selectedContent === 'podcasts') && (
							<PodcastsCardsList
								selectedItems={emptySelectedItems}
								handleCheckboxChange={emptyHandleCheckboxChange}
								handleBulkSelectionUpdate={emptyHandleBulkSelectionUpdate}
								onCountUpdate={(count) => reportSectionData('podcasts', count > 0)}
								selectAll={false}
								showPath={showPath as boolean}
								StatusVisible={StatusVisible}
								ContentView={ContentView}
								itemsPerView={itemsPerView}
								viewAll={selectedContent === 'podcasts'}
								handleViewAll={handleContentTypeChange}
								searchValue={searchValue}
							/>
						)}

						{/* Documents section - only visible when selected */}
						{(selectedContent === 'all' || selectedContent === 'documents') && (
							<DocumentsCardsList
								selectedItems={emptySelectedItems}
								handleCheckboxChange={emptyHandleCheckboxChange}
								handleBulkSelectionUpdate={emptyHandleBulkSelectionUpdate}
								onCountUpdate={(count) => reportSectionData('documents', count > 0)}
								selectAll={false}
								showPath={showPath as boolean}
								StatusVisible={StatusVisible}
								ContentView={ContentView}
								itemsPerView={itemsPerView}
								viewAll={selectedContent === 'documents'}
								handleViewAll={handleContentTypeChange}
								searchValue={searchValue}
							/>
						)}

						{/* Playlists section - only visible when selected */}
						{(selectedContent === 'all' || selectedContent === 'playlists') && status !== 'playlists' && !categoryId && (
							<PlaylistsCardsList
								selectedItems={emptySelectedItems}
								handleCheckboxChange={emptyHandleCheckboxChange}
								handleBulkSelectionUpdate={emptyHandleBulkSelectionUpdate}
								onCountUpdate={(count) => reportSectionData('playlists', count > 0)}
								selectAll={false}
								showPath={showPath as boolean}
								StatusVisible={StatusVisible}
								ContentView={ContentView}
								itemsPerView={itemsPerView}
								viewAll={selectedContent === 'playlists'}
								handleViewAll={handleContentTypeChange}
								searchValue={searchValue}
							/>
						)}
					</Grid>}
				</Box>
			</MainCard>
		</>
	);
};

// Add display name
GLobalSearchList.displayName = 'GLobalSearchList';

export default GLobalSearchList;